if (!customElements.get('click-to-copy-email')) {
  class ClickToCopyEmail extends HTMLElement {
    connectedCallback() {
      const emailLink = this.querySelector('.js-click-to-copy')
      if (!emailLink) return
      emailLink.addEventListener('click', this.clickToCopy)
    }

    clickToCopy = (event) => {
      event.preventDefault()
      let target = event.target

      if (!target.classList.contains("js-click-to-copy")) {
        target = event.target.closest(".js-click-to-copy")
      }

      const href = target.getAttribute('href')
      const emailAddress = href.split("mailto:")[1]

      const tooltipClickToCopyMessage = target.querySelector('.tooltip-click-to-copy-message')
      const tooltipCopiedMessage = target.querySelector('.tooltip-copied-message')

      navigator.clipboard.writeText(emailAddress).then(() => {
        tooltipClickToCopyMessage.classList.add('hidden')
        tooltipCopiedMessage.classList.remove('hidden')

        setTimeout(() => {
          tooltipCopiedMessage.classList.add('hidden')
          tooltipClickToCopyMessage.classList.remove('hidden')
        }, 2000)
      })
    }
  }

  customElements.define('click-to-copy-email', ClickToCopyEmail)
}